import { IconX } from '@tabler/icons-react';
import { ActionIcon, Grid, Group, NumberInput, Text, TextInput } from '@mantine/core';

const AudienceRuleFilter = ({ filter, updateFilter, removeFilter, readOnly }) => {
  const handleArrayValuesChange = (e) => {
    updateFilter({ ...filter, values: (e.target.value || '').split('|') });
  };

  const handleArrayElementChange = (value, index) => {
    let values = [...(filter.values || [])];
    values[index] = value;
    updateFilter({ ...filter, values });
  };

  if (filter === undefined) {
    return '';
  }

  let input = <></>;

  if (filter.inputType === 'string') {
    input = (
      <Grid.Col span={12}>
        <TextInput
          size="sm"
          label={filter.name}
          disabled={readOnly}
          value={(filter.values || []).join('|')}
          placeholder={filter.scope === 'google' ? '' : 'values separated by |'}
          onChange={handleArrayValuesChange.bind(this)}
          rightSection={
            !filter.required && (
              <ActionIcon variant="subtle" size="sm" onClick={removeFilter}>
                <IconX size={14} />
              </ActionIcon>
            )
          }
        />
      </Grid.Col>
    );
  } else if (filter.inputType === 'range') {
    const isInvalidFrom =
      filter.values[0] !== undefined &&
      filter.values[0] !== '' &&
      ((filter.min !== undefined && parseFloat(filter.values[0]) < filter.min) ||
        (filter.max !== undefined && parseFloat(filter.values[0]) > filter.max) ||
        (filter.step !== undefined && parseFloat(filter.values[0]) % filter.step !== 0));
    const isInvalidTo =
      filter.values[1] !== undefined &&
      filter.values[0] !== '' &&
      ((filter.min !== undefined && parseFloat(filter.values[1]) < filter.min) ||
        (filter.max !== undefined && parseFloat(filter.values[1]) > filter.max) ||
        (filter.step !== undefined && parseFloat(filter.values[1]) % filter.step !== 0));
    input = (
      <Grid.Col span={12}>
        <Group gap="xs" align="flex-end">
          <NumberInput
            w="100%"
            size="sm"
            label={`${filter.name} from`}
            disabled={readOnly}
            error={isInvalidFrom}
            step={filter.step}
            min={filter.min}
            max={filter.max}
            value={filter.values[0] || ''}
            placeholder={(filter.placeholder || [])[0]}
            onChange={(value) => handleArrayElementChange(value, 0)}
          />
          <Text size="sm">to</Text>
          <NumberInput
            w="100%"
            size="sm"
            error={isInvalidTo}
            step={filter.step}
            min={filter.min}
            max={filter.max}
            value={filter.values[1] || ''}
            placeholder={(filter.placeholder || [])[1]}
            onChange={(value) => handleArrayElementChange(value, 1)}
          />
          <ActionIcon variant="subtle" size="sm" onClick={removeFilter}>
            <IconX size={14} />
          </ActionIcon>
        </Group>
      </Grid.Col>
    );
  } else if (filter.inputType === 'number') {
    const isInvalid =
      filter.values[0] !== undefined &&
      filter.values[0] !== '' &&
      ((filter.min !== undefined && parseFloat(filter.values[0]) < filter.min) ||
        (filter.max !== undefined && parseFloat(filter.values[0]) > filter.max) ||
        (filter.step !== undefined && parseFloat(filter.values[0]) % filter.step !== 0));
    input = (
      <Grid.Col span={12}>
        <NumberInput
          w="100%"
          size="sm"
          label={filter.name}
          disabled={readOnly}
          error={isInvalid}
          step={filter.step}
          min={filter.min}
          max={filter.max}
          value={filter.values[0] || ''}
          placeholder={(filter.placeholder || [])[0]}
          onChange={(value) => handleArrayElementChange(value, 0)}
          rightSection={
            !filter.required && (
              <ActionIcon variant="subtle" size="sm" onClick={removeFilter}>
                <IconX size={14} />
              </ActionIcon>
            )
          }
        />
      </Grid.Col>
    );
  }
  return <Grid>{input}</Grid>;
};

export default AudienceRuleFilter;
